export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[550px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20open%20concept%20retail%20boutique%20interior%20with%20organized%20product%20displays%20on%20wooden%20shelving%20units%2C%20warm%20ambient%20pendant%20lighting%2C%20lush%20green%20plants%20creating%20natural%20atmosphere%2C%20clean%20contemporary%20design%20with%20neutral%20tones%20and%20natural%20textures%2C%20inviting%20shopping%20environment%20with%20soft%20golden%20hour%20glow%20through%20large%20windows&width=1800&height=900&seq=cta-bg-v3&orientation=landscape"
          alt="ACbuyspreadsheet - start smarter buying today"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-extrabold font-heading text-white tracking-tight mb-4">
            SMARTER BUYING STARTS HERE
          </h2>
          <p className="text-base md:text-lg text-white/75 leading-relaxed max-w-2xl mx-auto mb-8">
            Stop wasting time on disorganized shopping. The <strong>acbuyspreadsheet</strong> system 
            gives you complete control over every purchase decision with a clean, structured approach.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full text-base font-bold bg-primary-500 text-background-50 hover:bg-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <span className="w-7 h-7 rounded-full bg-background-50/20 flex items-center justify-center">
                <i className="ri-shopping-bag-line text-sm"></i>
              </span>
              ACBUY SPREADSHEET
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full text-base font-semibold border-2 border-white/50 text-white hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Visit Main Store
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}